export default __webpack_public_path__ + "static/logo-umbria-547bcc33a7e81964fed3f138289a9774.jpg";